<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { fromDatePicker } from '@/shared/utils/calendar-date';

/**
 * Un intervalle de dates: du tel jour au tel jour.
 *
 * Les listes ne savaient filtrer que sur une date unique, ce qui répond mal à
 * la question posée — « les comptes créés la semaine dernière ». Les deux
 * bornes sont ici, et la borne haute inclut sa journée entière, côté API.
 */
export default {
  name: 'DateRangeFilter',
  components: { flatPickr },
  props: {
    /** { from, to } en v-model, chaque borne en `yyyy-mm-dd` ou null. */
    modelValue: {
      type: Object,
      default: () => ({ from: null, to: null }),
    },
    fromPlaceholder: { type: String, default: 'Du…' },
    toPlaceholder: { type: String, default: 'Au…' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      config: {
        dateFormat: 'Y-m-d',
        altFormat: 'd M, Y',
        altInput: true,
      },
    };
  },
  computed: {
    from() {
      return this.modelValue?.from ?? null;
    },

    to() {
      return this.modelValue?.to ?? null;
    },

    /** Une borne haute antérieure à la borne basse ne rendrait jamais rien. */
    invalid() {
      return Boolean(this.from && this.to && this.to < this.from);
    },
  },
  methods: {
    update(bound, value) {
      this.$emit('update:modelValue', {
        from: this.from,
        to: this.to,
        [bound]: fromDatePicker(value),
      });
    },
  },
};
</script>

<template>
  <div class="date-range">
    <div class="date-range__inputs">
      <flat-pickr
        :value="from"
        class="list-input"
        :placeholder="fromPlaceholder"
        :config="config"
        data-testid="date-range-from"
        @input="update('from', $event)"
      />
      <span class="date-range__sep">→</span>
      <flat-pickr
        :value="to"
        class="list-input"
        :placeholder="toPlaceholder"
        :config="config"
        data-testid="date-range-to"
        @input="update('to', $event)"
      />
    </div>

    <span v-if="invalid" class="date-range__warning">
      La date de fin précède la date de début.
    </span>
  </div>
</template>
